import React, { PropTypes, Component } from 'react';
import { withNamespaces } from 'react-i18next';

import Button from 'patternity/lib/button2';

class BenefitsMobile extends Component {
  static propTypes = {
    description: PropTypes.string.isRequired,
    clickAction: PropTypes.func.isRequired,
    onCloseDialog: PropTypes.func.isRequired
  };

  render() {
    return (
      <section style={styles.welcomeSection} ref="welcomeSection">
        <span ref="skip" style={styles.skip} onClick={this.props.onCloseDialog}>{this.props.t('Skip')}</span>
          <div key='benefit-welcome'>
            <div ref='welcomeMessage' style={styles.welcomeMessage}>
              <div
                style={styles.description}
                dangerouslySetInnerHTML={{__html:this.props.description}}>
              </div>
            </div>
          </div>
        {this._renderNextButton()}
      </section>
    );
  };

  _renderNextButton = () => {
    return (
      <div style={styles.callToAction}>
        <Button type='primary' onClick={this.props.clickAction} style={styles.button}>
          {this.props.t('Continue')}
        </Button>
      </div>
    )
  };
}

const styles = {
  welcomeSection: {
    height: '100%'
  },
  welcomeBenefits: {
    margin: 'auto'
  },
  button: {
    marginTop: '20px',
    marginBottom: '30px'
  },
  description: {
    fontSize: '15px',
    whiteSpace: 'pre-wrap',
    margin: '0px auto 10px'
  },
  welcomeMessage: {
    overflow: 'scroll'
  },
  skip: {
    position: 'fixed',
    backgroundColor: '#fff',
    zIndex: '1',
    display: 'block',
    padding: '10px',
    right: '0px',
    top: '0px',
    fontSize: '15',
    color: '#969696' //patternity medium-grey
  },
  callToAction: {
    marginTop: '20px',
    textAlign: 'center'
  }
};


export default withNamespaces()(BenefitsMobile);



// WEBPACK FOOTER //
// ./src/advocate/onboarding/components/benefits_mobile.js